(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-split"] && !Shopify.designMode) return;
  try {
    
  class ContentSplitReveal extends HTMLElement {
    constructor() {
      super();
      this.elements = [];
      this.observer = null;
    }

    connectedCallback() {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) {
        this.querySelectorAll('.content-split__heading, .content-split__left, .content-split__rte').forEach(el => {
          el.classList.add('is-revealed');
        });
        return;
      }

      this.elements = this.querySelectorAll('.content-split__heading, .content-split__left, .content-split__rte');
      if (this.elements.length === 0) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              this.observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );

      this.elements.forEach((el) => this.observer.observe(el));
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  if (!customElements.get('content-split-reveal')) {
    customElements.define('content-split-reveal', ContentSplitReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offset-banner"] && !Shopify.designMode) return;
  try {
    
  class OffsetBannerReveal extends HTMLElement {
    constructor() {
      super();
      this.elements = [];
      this.observer = null;
    }

    connectedCallback() {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) {
        this.querySelectorAll('.offset-banner__line').forEach(el => {
          el.classList.add('is-revealed');
        });
        return;
      }

      this.elements = this.querySelectorAll('.offset-banner__line');
      if (this.elements.length === 0) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              this.observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );

      this.elements.forEach((el) => this.observer.observe(el));
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  if (!customElements.get('offset-banner-reveal')) {
    customElements.define('offset-banner-reveal', OffsetBannerReveal);
  }

  } catch(e) { console.error(e); }
})();
})();
